import designConfig from '@/core/design-config'
import renderStyles from '@/core/renderStyles'
import renderHTML from '@/core/renderHTML'
import { store } from '@/store'
import localStorageService from '@/core/local-storage'

export const preventBodyScroll = (value) => {
  const bodyClasses = document.getElementsByTagName('html')[0].classList
  if (value) {
    bodyClasses.add('prevent-body-scroll')
  } else {
    bodyClasses.remove('prevent-body-scroll')
  }
}

export const nextIndex = (items, title, expression) => {
  const defaultBook = items.find(b => b.title === 'My first space')

  let index = defaultBook ? 2 : 1

  const arr = items.filter(item => {
    return item.title.split(expression)[0] === title
  })

  if (arr.length) {
    arr.map(item => item.title.split(expression)[1]).sort((a, b) => +a < +b ? -1 : 1).forEach(item => {
      if (index === +item) index++
    })
  }

  return index
}

export const parseHTML = (html) => {
  const step1 = html.replace(/<\s*p*>( ?)<\s*\/*p>/g, '<br/>')
  return step1.replace(/<\s*h1*><\s*\/*h1>/g, '<h1><br/></h1>')
}

export const selectText = (node) => {
  if (document.body.createTextRange) {
    const range = document.body.createTextRange()
    range.moveToElementText(node)
    range.select()
  } else if (window.getSelection) {
    const selection = window.getSelection()
    const range = document.createRange()
    range.selectNodeContents(node)
    selection.removeAllRanges()
    selection.addRange(range)
  } else {
    console.warn('Could not select text in node: Unsupported browser.')
  }
}

export const unselectText = () => {
  if (window.getSelection) {
    window.getSelection().removeAllRanges()
  } else if (document.selection) {
    document.selection.empty()
  }

  if (document.activeElement) {
    document.activeElement.blur()
  }
}

export const generateHTML = (text, settings, title) => {
  if (!text) return null

  const maxW = designConfig.columns[settings?.columnWidth]
  const fontF = designConfig.fontFamilies[settings?.fontFamily]
  const fontSize = designConfig.fontSizes[settings?.fontSize]

  return renderHTML({
    title: title,
    body: parseHTML(text),
    style: renderStyles(maxW, fontF, fontSize)
  })
}

export const getNonDeletedTextContent = (topNode) => {
  let text = ''
  topNode.descendants((node) => {
    if (node.isBlock) {
      text += '\n'
    } else if (node.isText) {
      text += node.text
    }
  })
  return text.replace(/(^\s*)|(\s*$)/gi, '').replace(/[ ]{2,}/gi, ' ').replace(/\n /, '\n').replace(/\n{2,}/gi, '\n')
}

export const countWords = (doc) => {
  const textContent = getNonDeletedTextContent(doc)
  const docContent = textContent + ' '
  const docWords = docContent.split(/[\n ]+/)

  const docNumNoSpace = docWords.join('').length
  const docNumWords = docNumNoSpace ? docWords.length : 0

  return docNumWords === 0 ? 0 : docNumWords - 1
}

export const getPosition = (menu, block, btnRef, staticTop) => {
  const height = window.innerHeight
  const parent = menu.getBoundingClientRect()
  const content = block.getBoundingClientRect()
  const btn = btnRef.getBoundingClientRect()

  const top = (parent.top + parent.height + content.height > height) || staticTop ? 'bottom: 100%' : 'top: 42px'
  const left = btn.right > window.innerWidth || btn.right + content.width > window.innerWidth ? `left: ${btn.right - parent.left - content.width}px` : `left: ${btn.left - parent.left}px`

  return store.getters.isMobile ? `left: 0px; ${top}` : `${left}; ${top}`
}

export const onDragEnd = () => {
  const className = 'grabbing'
  const html = document.getElementsByTagName('html').item(0)
  if (html && new RegExp(className).test(html.className) === true) {
    // Remove className with the added space (from setClassToHTMLElement)
    html.className = html.className.replace(
      new RegExp(' ' + className),
      ''
    )
    // Remove className without added space (just in case)
    html.className = html.className.replace(new RegExp(className), '')
  }
}

export const onStart = () => {
  const className = 'grabbing'
  const html = document.getElementsByTagName('html').item(0)
  if (html && new RegExp(className).test(html.className) === false) {
    html.className += ' ' + className // use a space in case there are other classNames
  }
}

// convert hex color to rgb
export const hexToRGB = (hex) => {
  const hexReg = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  if (!hex.match(hexReg)) return hex

  if (hex.length === 4 || hex.length === 7) {
    const color = hex.replace(hexReg, (m, r, g, b) => '#' + r + r + g + g + b + b)
      .substring(1).match(/.{2}/g)
      .map(x => parseInt(x, 16))

    return `rgb(${color})`
  }
}

// convert rgb to hex
export const rgbToHex = (color) => {
  const regEx = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/

  if (regEx.test(color)) {
    const match = regEx.exec(color)
    const r = Number(match[1])
    const g = Number(match[2])
    const b = Number(match[3])

    return '#' + [r, g, b].map(x => {
      const hex = x.toString(16)
      return hex.length === 1 ? '0' + hex : hex
    }).join('')
  } else {
    return color
  }
}

export const updatePreviousThemesLocalStorage = (user, key, value) => {
  const previousThemes = localStorageService.getItem('previous-themes') || {}
  const userPreviousThemes = previousThemes[user?.id] || { dark: '', light: '' }
  userPreviousThemes[key] = value
  previousThemes[user?.id] = userPreviousThemes
  localStorageService.setItem('previous-themes', previousThemes)
}

export const dispatchChangingDesign = (settings) => {
  // it is necessary to switch the theme of the button in extensions
  const dispatchDarkMode = new CustomEvent('darkModeEvent', {
    detail: {
      isDarkMode: settings.theme.includes('Dark') || settings.theme === 'Dracula'
    }
  })
  window.dispatchEvent(dispatchDarkMode)
}

export const detectMob = () => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ]

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem)
  })
}

export const caseInsensitiveIncludes = (text, search) => {
  if (search.length > text.length) {
    return false
  } else {
    return text.indexOf(search, 0) !== -1
  }
}

export function replaceHighlightedText (text, query) {
  const queryRegExp = new RegExp(query, 'ig')
  const position = text.search(queryRegExp)
  const word = text.slice(position, query.length + position)

  const regExp = new RegExp(word, 'ig')
  return `<p>${text.replace(regExp, `<strong class="text-app-color">${word}</strong>`)}</p>`
}

export const getHighlightedItems = (text, query = '') => {
  var span = document.createElement('span')
  span.innerHTML = text.replace(/(<([^>]+)>)/ig, '\n')
  const highlight = span.textContent.split('\n').filter(item => caseInsensitiveIncludes(item.toLowerCase(), query.toLowerCase()))

  if (highlight.length > 0) {
    return parseQuery(highlight, query)
  } else {
    const result = []
    const splittedQuery = query.trim().split(' ')

    splittedQuery.forEach((str) => {
      var span = document.createElement('span')
      span.innerHTML = text.replace(/(<([^>]+)>)/ig, '\n')
      const highlight = span.textContent.split('\n').filter(item => caseInsensitiveIncludes(item.toLowerCase(), str.toLowerCase()))

      if (highlight.length > 0 && str.length > 1) {
        result.push(...parseQuery(highlight, str))
      }
    })

    return result
  }
}

function parseQuery (arr, query) {
  const result = []

  arr.forEach((item) => {
    if (item.length > 130) {
      const splittedByDot = item.split('.').filter(item => caseInsensitiveIncludes(item.toLowerCase(), query.toLowerCase()))

      splittedByDot.forEach(el => {
        result.push(replaceHighlightedText(el, query))
      })
    } else {
      result.push(replaceHighlightedText(item, query))
    }
  })

  return result
}
